export default __webpack_public_path__ + "static/media/favicon.7d596bed.ico";